import React, { useEffect, useState } from "react";
import "../styles/Home.css";

const WORDS = ["Web Developer", "UI/UX Designer", "Coding Instructor", "Author of WEB101"];

const Home = () => {
  const [text, setText] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  /* Typewriter with delete */
  useEffect(() => {
    const currentWord = WORDS[wordIndex];
    let delay = deleting ? 55 : 105;

    if (!deleting && charIndex === currentWord.length) {
      delay = 2200;
    }
    if (deleting && charIndex === 0) {
      delay = 400;
      setDeleting(false);
      setWordIndex((prev) => (prev + 1) % WORDS.length);
      return;
    }

    const timer = setTimeout(() => {
      if (!deleting && charIndex < currentWord.length) {
        setText(currentWord.substring(0, charIndex + 1));
        setCharIndex((c) => c + 1);
      } else if (!deleting && charIndex === currentWord.length) {
        setDeleting(true);
      } else if (deleting) {
        setText(currentWord.substring(0, charIndex - 1));
        setCharIndex((c) => c - 1);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [charIndex, deleting, wordIndex]);

  return (
    <section className="hero" id="home">
      {/* Grid lines decoration */}
      <div className="hero-grid" aria-hidden="true">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="hero-grid-line" />
        ))}
      </div>

      {/* Corner brackets */}
      <div className="hero-bracket hero-bracket--tl" aria-hidden="true" />
      <div className="hero-bracket hero-bracket--br" aria-hidden="true" />

      <div className={`hero-content ${mounted ? "hero-content--in" : ""}`}>
        {/* Mono label */}
        <p className="hero-label">
          <span className="hero-label-dot" />
          Available for new projects
        </p>

        {/* Name */}
        <h1 className="hero-name">
          Hi, I'm{" "}
          <span className="hero-name-accent">Roy Zaouk</span>
        </h1>

        {/* Typewriter */}
        <div className="hero-typewriter">
          <span className="hero-typewriter-text">{text}</span>
          <span className="hero-cursor" aria-hidden="true">|</span>
        </div>

        {/* Divider */}
        <div className="hero-divider" />

        {/* Description */}
        <p className="hero-description">
          I craft cutting-edge websites, intuitive UI/UX experiences, and
          scalable digital platforms — helping businesses grow, attract customers,
          and increase revenue.
        </p>

        {/* Buttons */}
        <div className="hero-actions">
          <a href="#projects" className="btn-primary">
            View Projects
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <a href="#contact" className="btn-secondary">Contact Me</a>
        </div>

        {/* Stats */}
        <div className="hero-stats">
          {[
            { value: "20+", label: "Projects Built" },
            { value: "3+", label: "Years of experience" },
            { value: "1", label: "Book Published" },
          ].map(({ value, label }) => (
            <div key={label} className="hero-stat">
              <span className="hero-stat-value">{value}</span>
              <span className="hero-stat-label">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero-scroll" aria-label="Scroll down">
        <div className="hero-scroll-line" />
        <span className="hero-scroll-text">Scroll</span>
      </div>
    </section>
  );
};

export default Home;
